import "./Footer.css";

import * as React from "react";

import facade from "../../../../utils/facade";

export default function Footer() {
  React.useLayoutEffect(() => {
    const footer = document.getElementById(
      "loa-admin-footer"
    ) as HTMLDivElement;
    if (footer) {
      facade.fire("footer-element", footer);
    }
  }, []);
  return <div id="loa-admin-footer" className="loa-footer"></div>;
}
